import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "@/components/PageLayout";

const NotFound = () => {
  return (
    <PageLayout
      title="Page Not Found"
      description="The page you requested does not exist."
    >
      <div className="rounded-lg bg-white p-6 shadow-md">
        <p className="mb-4 leading-7 text-gray-700">
          Use the navigation links to return to the calculator or read the
          Skadis layout guide.
        </p>
        <Link className="font-semibold text-blue-600 underline underline-offset-2" to="/">
          Go to the calculator
        </Link>
      </div>
    </PageLayout>
  );
};

export default NotFound;
